// extracted by mini-css-extract-plugin
export default {"onGoingMain":"onGoingStyle_onGoingMain__P1gwe","custom_message":"onGoingStyle_custom_message__ZsckB"};